import axios from '../plugins/axios';

export const state = () => ({
  items: [],
});

export const mutations = {

  ADD_TO_CART(state, data) {
    let index= state.items.findIndex((item)=>{
        if(item.pid==data.pid && item.vid==data.vid)
          return true;
    });
    if(index==-1){
      state.items.push(data);
    }
    else {
      state.items[index].product=data.product;
      state.items[index].qty=data.qty
    }
    localStorage.setItem('cart_items', JSON.stringify(state.items));
  },
  SHOW(state, res) {
    state.model = res;
  },
  INIT(state, res) {
    state.items = res;
  },
  REMOVE(state, item) {
    let index= state.items.findIndex((vitem)=>{
      if(vitem.pid==item.pid && vitem.vid==item.vid)
        return true;
    });
    if(index>-1){
      state.items.splice(index,1);
    }
    localStorage.setItem('cart_items', JSON.stringify(state.items));
  },
  UPDATE_ITEM_QUANTITY(state, payload)
  {
    state.items[payload.index].qty = payload.quantity
  },
  Clear(state) {
    state.items = [];
    localStorage.setItem('cart_items', JSON.stringify(state.items));
  }
}

export const actions = {
  add({commit}, data) {
    commit('ADD_TO_CART', data);
  },
  show({commit}, data) {
    commit('SHOW', data);
  },
  remove({commit}, data) {
    commit('REMOVE', data);
  },
  updateItemQuantity({commit}, payload) {
    commit('UPDATE_ITEM_QUANTITY', payload)
  },
  clear({commit}) {
    commit('Clear');
  },
  async init({commit}) {
    try {
      let items = JSON.parse(localStorage.getItem('cart_items')) || [];
      let ids = items.map( item => item.product.id );
      let {data} = await axios.post('site/get/products', {products_id: ids});
      if (data) {
        let exp = [];
        for (let cartItem of items) {
          let product = data.find( (item) => item.id == cartItem.product.id);
          //console.log("this is product",product);
          if(!(!product.variants[0].is_pre_order && product.variants[0].qty === 0)){
            exp.push({
              vid: cartItem.vid,
              pid: product.id,
              product: product,
              qty: cartItem.qty,
              promotion_id: product.promotion && product.promotion.id ? product.promotion.id : null
            });
          }
        }
        localStorage.setItem('cart_items', JSON.stringify(exp));
        commit('INIT', exp);
      }
    }catch (e)
    {
      console.log("error in cart",e);
    }finally {
    //
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
